<template>
  <div>
    <page-header has-return :page="page" @onReturn="$router.back" />
    <filter-manager
      ref="filterRef"
      :filters="filterManagerConfig"
      :display-advanced="false"
      class="search-bar"
      search-icon="fa fa-sync pr-2"
      search-container-class="btn-process"
      search-text=""
      v-model="model.filters"
      @search="proceed"
    >
      <div class="col d-flex justify-content-end align-items-center mt-4">
        <dropdown
          v-if="canQueue"
          icon="fas fa-print"
          :items="reportOptions"
          title="Seleccione"
        />
      </div>
    </filter-manager>
    <queue-report-status
      :queue-report="queueInfo"
      @on-cancel="cancelQueue"
      @on-download="downloadQueueReport"
    />
  </div>
</template>
<script>
import PageHeader from 'PageHeader';
import FilterManager from 'FilterManager';
import Vue from 'vue';
import hubService from '@/services/api/hub/hubservice.js';
import LocationApi from '@/services/api/location.api';
import CodeApi from '@/services/api/code.api';
import ReportServices from '@/modules/report/api';
import queueReportTypes from '@/utils/constants/queueReportTypes';
import QueueReportStatus from '@/views/progress/shared/components/QueueReportStatus.vue';
import queueReportStatus from '@/utils/constants/queueReportStatus';
import DocumentServices from '@/modules/report/document';
import Dropdown from 'dropdown';

export default {
  components: {
    PageHeader,
    FilterManager,
    QueueReportStatus,
    Dropdown,
  },
  data: () => ({
    model: {
      collections: {
        academicYears: [],
        ores: [],
        schoolTypes: [],
        determinationTypes: [],
      },
      filters: {
        academicYear: null,
        ore: null,
        schoolType: null,
        determinationType: null,
      },
    },
    queueInfo: null,
  }),
  computed: {
    page() {
      return {
        icon: 'fas fa-file-invoice',
        title: 'Análisis de Alternativa de Ubicación en la Oficina Regional',
        routes: [
          'Informes',
          'Análisis de Alternativa de Ubicación en la Oficina Regional',
        ],
      };
    },
    canQueue() {
      return (
        this.queueInfo === null ||
        this.queueInfo.statusId === queueReportStatus.Completed ||
        this.queueInfo.statusId === queueReportStatus.Failed
      );
    },
    filterManagerConfig() {
      return [
        {
          name: 'academicYear',
          component: 'custom-drop-down',
          fieldKey: 'id',
          fieldName: 'description',
          label: 'Año Académico',
          placeholder: 'Seleccionar',
          error: 'El año académico es requerido.',
          validations: 'required',
          class: 'col-md col-12',
          options: this.model.collections.academicYears,
          value: this.model.filters.academicYear
        },
        {
          name: 'ore',
          component: 'custom-drop-down',
          fieldKey: 'id',
          fieldName: 'name',
          label: 'ORE',
          placeholder: 'Seleccionar',
          validations: 'required',
          error: 'El ORE es requerido.',
          class: 'col-md col-12',
          options: this.model.collections.ores,
          value: this.model.filters.ore,
          disabled: this.model.collections.ores.length <= 1,
        },
        {
          name: 'schoolType',
          component: 'custom-drop-down',
          fieldKey: 'id',
          fieldName: 'name',
          label: 'Tipo de Locación',
          placeholder: 'Seleccionar',
          class: 'col-md col-12',
          options: this.model.collections.schoolTypes,
          value: this.model.filters.schoolType,
          disabled: this.model.collections.schoolTypes.length <= 0,
        },
        {
          name: 'determinationType',
          component: 'custom-drop-down',
          label: 'Determinación de Escuela Privada',
          placeholder: 'Seleccione',
          fieldName: 'name',
          fieldKey: 'id',
          class: 'col-md col-12',
          options: this.model.collections.determinationTypes,
          value: this.model.filters.determinationType,
          disabled: this.model.collections.determinationTypes.length <= 0,
        },
      ];
    },
    reportOptions() {
      return [
        {
          label: 'Procesar',
          icon: 'fas fa-sync text-green',
          visible: true,
          click: () => this.proceed(),
        },
      ];
    },
  },
  async mounted() {
    await this.getInitialFilters();
    const res = await ReportServices.getPreviousGeneratedReport([
      queueReportTypes.AnalysisAlternativeLocationRegionalOffice,
    ]);
    this.queueInfo = res.data !== '' ? res.data : null;
  },
  created() {
    Vue.use(hubService);
    this.$userHub.$on(
      'hub-receive-status-queue-report',
      this.updateReceivedQueueStatusByHub
    );
  },
  beforeDestroy() {
    //clean SignalR event
    this.$userHub.$off(
      'hub-receive-status-queue-report',
      this.updateReceivedQueueStatusByHub
    );
  },
  methods: {
    async getInitialFilters() {
      const {
        data,
      } = await CodeApi.getRegionalOfficeAlternativeLocationAnalisysFilters();
      Object.assign(this.model.collections, data);

      await this.getOres();
    },
    async getOres() {
      const { data } = await LocationApi.getOres();
      this.model.collections.ores = data;
      if (data?.length === 1) {
        this.model.filters.ore = data[0];
      }
    },
    async proceed() {
      const isValid = await this.$refs.filterRef.$refs.formValidator.validate();
      if (!isValid) return;

      await ReportServices.queueReport(
        'AnalysisAlternativeLocationRegionalOffice',
        {
          academicYearId: this.model.filters.academicYear?.id,
          oreId: this.model.filters.ore?.id,
          locationTypeId: this.model.filters.schoolType?.id,
          determinationId: this.model.filters.determinationType?.id,
        }
      ).then((res) => {
        this.queueInfo = {
          executionLogId: res.data,
          statusId: queueReportStatus.Pending,
          expired: false,
        };
      });
    },
    async cancelQueue(executionLogId) {
      ReportServices.cancelQueueReport(executionLogId)
        .then((res) => {
          if (res.data) {
            this.ShowToast(
              'Proceso Exitoso',
              'La ejecución del reporte ha sido cancelada exitosamente.',
              'success'
            );
            this.queueInfo = null;
          }
        })
        .catch((err) => {
          this.ShowToast('', err.response?.data?.message, 'error');
        });
    },
    updateReceivedQueueStatusByHub(res) {
      this.queueInfo = res.respose;
    },
    async downloadQueueReport(executionLogId) {
      ReportServices.downloadQueueReport(executionLogId)
        .then((res) => DocumentServices.Download(res.data))
        .catch((err) => {
          this.ShowToast('', err.response?.data?.message, 'error');
        });
    },
  },
};
</script>
